// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#expansion-panels-help .v-expansion-panel[data-v-f17d044c]:after{border-top:none}", ""]);
// Exports
module.exports = exports;
